import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PresaleDataService } from '../../services/connection-services/data.service';
import { EventService } from '../../services/event.service';

@Component({
  selector: 'app-cta-banner',
  standalone: false,
  templateUrl: './cta-banner.component.html',
  styleUrl: './cta-banner.component.scss',
})
export class CtaBannerComponent {
  
  @ViewChild('modalContour', { static: false })
  modalContour!: ElementRef;

  modalOrb!: ElementRef;

  constructor(public bsModalRef: BsModalRef) {}

  private readonly eventService = inject(EventService);
  private readonly dataService = inject(PresaleDataService);


  closeModal(): void {
    this.bsModalRef.hide();
  }

  onBuyClick(): void {
    this.closeModal();
    if(!this.dataService.walletAddress) this.dataService.connectWallet();
  }

}
